import { useMutation, useQueryClient } from 'react-query';
import { useCurrentUserCtx } from 'contexts/CurrentUser';
import { AnchorAPI } from 'modules/AnchorAPI';
import { useParams } from 'react-router-dom';
import { FETCH_EPISODES } from './useFetchEpisodes';

function useCreateEpisode() {
  const queryClient = useQueryClient();
  const {
    state: { webStationId },
  } = useCurrentUserCtx();
  const { integrationName } = useParams<{ integrationName: string }>();

  const { mutate } = useMutation(
    ({ title, description }: { title?: string; description?: string }) => {
      if (!webStationId) {
        Promise.reject(
          new Error('webStationId is required to create a new episode')
        );
      }
      return AnchorAPI.createNewEpisode({
        webStationId: webStationId!,
        title,
        description,
        ...(integrationName === 'riverside' && {
          metadata: { riversideGenerated: true },
        }),
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([FETCH_EPISODES, webStationId]);
      },
    }
  );
  return { createNewEpisode: mutate };
}

export { useCreateEpisode };
